import * as React from 'react';

import type { User } from '../types/User';

// This is only used when rendering a Consumer without a Provider above it.
const defaultValue: User = {
  id: '',
  type: 'user',
  name: '',
  email: '',
  language: '',
  accountHost: '',
};

const Context = React.createContext<User>(defaultValue);
const { Consumer, Provider } = Context;

const withCurrentUser =
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  (UserComp: React.ComponentType<any>) => (props: any) => (
    <Consumer>
      {currentUser => <UserComp currentUser={currentUser} {...props} />}
    </Consumer>
  );

const useCurrentUser = () => {
  const currentUser = React.useContext(Context);
  if (currentUser === defaultValue) {
    throw new Error(
      'useCurrentUser must be used within a CurrentUser.Provider',
    );
  }
  return currentUser;
};

export {
  Context,
  Provider,
  Consumer,
  defaultValue,
  withCurrentUser,
  useCurrentUser,
};
